import { getCookie, setCookie } from 'cookies-next';

import { FRONTEND_DOMAIN } from './env.utils';

const frontendUrl = new URL(FRONTEND_DOMAIN);
const AFFILIATE_COOKIE = 'nofomo-affiliate';
const EXPIRATION_DAYS = 5;

/**
 * @deprecated This is being replaced by affiliate own flow.
 */
export const updateAffiliate = (affiliate: string) => {
  const today = new Date();
  today.setDate(today.getDate() + EXPIRATION_DAYS);
  setCookie(AFFILIATE_COOKIE, affiliate, {
    sameSite: 'none',
    path: '/',
    secure: true,
    expires: today,
    domain: frontendUrl.hostname,
  });
};

/**
 * @deprecated This is being replaced by affiliate own flow.
 */
export const getAffiliate = () => {
  const affiliate = getCookie(AFFILIATE_COOKIE);
  return typeof affiliate === 'string' ? affiliate : undefined;
};
